/* @fflow */
import React, { Component } from 'react';
import { AnnotationsDownloadContainer } from 'containers/DownloadContainers';
import { Row } from 'components/UIKit/Flex';
export default class AnnotationsToolbar extends React.Component {

  render(): React.Element {
    return (
      <Row>
        <AnnotationsDownloadContainer />
      </Row>
    );
  }
}
